export const CHECKOUT_URL = "https://nutrition-en.impultienda.ar/checkout/";

export const images = {
  collection: "https://cdn.magicpatterns.com/uploads/qGoP7DAwinQuFF2mpJBDye/MOCKUP_NUTRITION-EN.png",
  author: "https://cdn.magicpatterns.com/uploads/oT3qGrNWbAbVCQhwgTqS55/Dr._Henry_Wells_-_DIABETES.png",
};

export const collectionHighlights = [
  "6 specialized educational volumes",
  "5 exclusive professional bonuses",
  "Renal physiology and kidney function references",
  "Nutrition assessment frameworks",
  "Dietary considerations and nutrient reference materials",
  "Renal nutrition case studies",
  "Nutrition care planning worksheets",
  "Clinical documentation templates",
];

export const offerIncludes = [
  "Six specialized educational volumes",
  "Five professional bonuses",
  "Renal physiology and kidney function references",
  "Nutritional assessment frameworks",
  "Nutrient comparison tables",
  "CKD nutrition education references",
  "Nutrition care planning worksheets",
  "Hypothetical clinical case studies",
  "Documentation and monitoring templates",
  "No recurring subscription",
];

export const finalIncludes = [
  "Six specialized educational volumes",
  "Five professional bonuses",
  "Renal physiology reference materials",
  "Nutritional assessment frameworks",
  "Nutrient comparison resources",
  "CKD nutrition educational references",
  "Nutrition care planning worksheets",
  "Hypothetical clinical case studies",
  "Documentation and monitoring templates",
];

export const recentBuyers = [
  { name: "Valentina R.", country: "Colombia" },
  { name: "Mateo G.", country: "Mexico" },
  { name: "Camila S.", country: "Argentina" },
  { name: "Sofía M.", country: "Spain" },
  { name: "Diego P.", country: "Chile" },
  { name: "Lucía F.", country: "Peru" },
  { name: "Andrés C.", country: "Ecuador" },
  { name: "Gabriela T.", country: "Uruguay" },
  { name: "Javier L.", country: "Costa Rica" },
  { name: "Isabella V.", country: "Dominican Republic" },
  { name: "Martina A.", country: "Paraguay" },
  { name: "Carlos E.", country: "Guatemala" },
  { name: "Daniela H.", country: "Venezuela" },
  { name: "Fernando O.", country: "Panama" },
  { name: "Paula N.", country: "Bolivia" },
];
